import React from 'react';
import { Table } from 'semantic-ui-react';
import {
  columnName,
  columnDataExists,
  columnRowCount,
  columnValidationDate,
  columnTools,
} from '@/constants/fields';
import TableWrapper from '@/components/table/TableWrapper';
import NoRows from '@/components/table/NoRows';
import DataManagementDictionariesTableColumns from './DataManagementDictionariesTableColumns';
import DataManagementDictionariesTableRows from './DataManagementDictionariesTableRows';

const DataManagementDictionariesTable = ({ category, code, dictionaries }) => {
  if (dictionaries?.length === 0) {
    return (<NoRows icon="table" entity="dictionary" />);
  }

  const columns = [columnName, columnDataExists, columnRowCount, columnValidationDate, columnTools];

  return (
    <TableWrapper
      celled
      solid
      selectable
      sticky
      className="aridhia-dictionary-data-management-table"
      columns={columns}
    >
      <Table.Header>
        <DataManagementDictionariesTableColumns columns={columns} />
      </Table.Header>
      <Table.Body>
        <DataManagementDictionariesTableRows
          category={category}
          code={code}
          columns={columns}
          dictionaries={dictionaries}
        />
      </Table.Body>
    </TableWrapper>
  );
};

export default DataManagementDictionariesTable;
